import React from 'react';
import EventBarrier from 'photoswipe/event-barrier/event-barrier';
import { Link } from 'react-router-dom';

import Styled from 'styled';

import Controls from './controls';
import Header from '../../header/header';

import defaultStyles from './description.scss';

import { Props as ButtonsProps } from './buttons/buttons';
import { DescriptionFragment } from './description.graphql';
import ImageTagSlugs from './tag-slugs/image-tag-slugs';
import ImageTitle from './image-title/image-title';
import { PhotoPresentationBranding } from 'lib/google/dfp/ad-units/branding';

export interface Props extends DescriptionFragment {
    onMore?: ButtonsProps['onMore'];
    styles: typeof defaultStyles;
    id: string;
    commentId?: string;
}

const Description: React.FC<Props> = props => {
    const { styles, id, title, post, createdTime, ...rest } = props;

    return (
        <EventBarrier className={styles.description}>
            <PhotoPresentationBranding />
            <div className={styles.header}>
                <Header {...post} lastChangeTime={createdTime} />
                {post.postType === 'POST_ALBUM' ? (
                    <h2 className={styles.postTitle}>
                        <Link to={post.href || ''} className={styles.postTitleLink}>
                            {post.title}
                        </Link>
                    </h2>
                ) : null}
                <ImageTitle id={id} title={title} postUserUsername={post.user?.username} />
            </div>
            <ImageTagSlugs id={id} />
            <Controls id={id} {...rest} />
        </EventBarrier>
    );
};

export default Styled(defaultStyles)(Description);
